import ProfileList from '../components/ProfileList'

const getProfileComponent = (component, onItemClick) => {
  if (!component?.type) {
    return null
  }

  switch (component.type) {
    case 'list':
      return <ProfileList data={component} onItemClick={onItemClick} />
    default:
      return null
  }
}

export default getProfileComponent
